
import Header from "../components/header";
import Sidebar from "../components/sidebar";
import CreditCustomer from "../components/creditcustomer";
import Footer from "../components/footer";

function CreditCustomerPage() {
  return (
    <div>
    <div className='wrapper'>
      <Header />
      <Sidebar /> 
      <CreditCustomer /> 
    </div>
    <Footer /> 
  </div>
  // <Login/>
  );
}
export default CreditCustomerPage;
